import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import {useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


function Header() {
    const [open, setOpen] = useState(false)

    return (
        <header>
            <div className='bar'>
                <a href="/"><span className="image"></span></a>
                <button className='menu-toggle' onClick={() => setOpen(!open)}><FontAwesomeIcon icon={open ? faXmark : faBars}/></button>
                <div className={'menu' + (open ? ' open' : '')}>
                    <a href="/">HOME</a>
                    <a href="/search">RICERCA PRODOTTI MEPA</a>
                     {/*<a href="/order-status">STATO ORDINE</a> */}
                    <a href="/catalogo.xlsx">SCARICA CATALOGO</a>
                    <a href="http://www.simplesystems.eu/" target="_blank" rel="noreferrer">COMPUTER SIMPLE</a>
                    <a href="/contacts">CONTATTI</a>
                    <a href="/order">ORDINE MINIMO</a>
                </div>
            </div>
        </header>
    )
}

export default Header